import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/download_staging/69e4aeed8485e200142bb484/relationalact/src/app/home-screen/components/HomeShell.tsx");
